import { Injectable, OnInit } from '@angular/core';
import {HttpClient, HttpErrorResponse, HttpHeaders, } from '@angular/common/http';
import {Observable, throwError } from 'rxjs';
import {tap,catchError, retry} from 'rxjs/operators';
import {IApproval, IAppByRole, IEmployee, IDocument} from './approval';
import { Globals } from 'src/app/_utlity/globals';
import { GlobalService } from 'src/app/_services/CommonServices/global.service';
import { AppInsightsService } from 'src/app/_services/ReportServices/app-insights.service';
import { SAPID } from 'src/app/_shared/common/global-variables';

@Injectable({
  providedIn: 'root'
})

export class ApprovalService implements OnInit{
  access_token: string="";
  employeeId:string="";
  sapId:SAPID;
  body:IEmployee={
    ReqId:undefined,
    SAPID:undefined,
    Remarks:undefined
  }; // To Send Data in Post Request

//#region  ApprovalDashBoard Variable

  private getPendingRequestUrl = 'DashBoard/GetPendingRequest';
  private getPendingRoleByAppSliderUrl = 'DashBoard/GetApproverAppwiseRoles';
  private postRejectRequestUrl ='DashBoard/';
  private postApproveRequestUrl = 'DashBoard/';

//#endregion

//#region MyRequestsDashBoard Variable

  private getMyRequestUrl='DashBoard/GetRequestByEMPId';
  private getRoleByAppSliderMyRequestUrl='DashBoard/GetRequesterAppwiseRoles';
  private postCancelRequestUrl='DashBoard/';
  private getDocuNameUrl='DashBoard/GetDocument';
 isRedirectFromDashBoard = false;
//#endregion

  constructor(private global: GlobalService,private http: HttpClient,private globals:Globals, private appInsights:AppInsightsService,private globalServices: GlobalService) {
    
  }

   ngOnInit():void{
     this.employeeId= this.global.UserLoggedInSAPID;
     if (this.employeeId!="") {
       this.employeeId=this.global.UserLoggedInSAPID;
     }    
     this.body.ReqId=null;
   }
//#region ApprovalsDashBoard

   
   
  getPendingRequests():Observable<IApproval[]>{
    this.employeeId= this.global.GetUserLoggedInSAPID();
    const sapId = <SAPID>
    {
      ReqSAPID:this.employeeId
    }
    const httpHeaders = new HttpHeaders({  
                          });
    return this.http.post<IApproval[]>(this.globalServices.baseUrl+ this.getPendingRequestUrl, sapId,{headers:httpHeaders})
    .pipe( retry(1),
      catchError(this.handleError)
      );
  }

  getPendingRoleByAppSlider():Observable<IAppByRole[]>{
    this.employeeId=this.global.GetUserLoggedInSAPID();
    const sapId = <SAPID>
    {
      ReqSAPID:this.employeeId
    }
    const httpHeaders = new HttpHeaders({ 
                              });
    return this.http.post<IAppByRole[]>(this.globalServices.baseUrl + this.getPendingRoleByAppSliderUrl, sapId,{headers:httpHeaders})
    .pipe(tap(data => data), retry(1),
      catchError(this.handleError)
      );
  }

  postRejectRequest(employee : IEmployee[]){
    this.appInsights.logEvent('rejeactRequest',employee);
    const httpHeaders = new HttpHeaders({
                                'Content-Type': 'application/json',     
                              });
      return this.http.post<IApproval>(this.globalServices.baseUrl+this.postRejectRequestUrl + 'RejectDelegationRequest',employee,{headers:httpHeaders})
      .pipe(
        tap(data=> console.log('Reject Request: '+ JSON.stringify(data))),
        catchError(this.handleError)
      );
  }

  postApproveRequest(employee : IEmployee[]):Observable<void>
  {
    this.appInsights.logEvent('Approve Request',employee);
    const httpHeaders = new HttpHeaders({
                            'Content-Type': 'application/json',
          });
    return this.http.post<void>(this.globalServices.baseUrl +this.postApproveRequestUrl + 'ApproveDelegationRequest',employee,{headers:httpHeaders})
    .pipe(
      tap(data=> console.log('Approved Request: '+ JSON.stringify(data))),
      catchError(this.handleError)
    );
  }

//#endregion

//#region MyRequestsDashBoard

  getMyRequest():Observable<IApproval[]>{
    this.employeeId=this.global.GetUserLoggedInSAPID();
    const sapId = <SAPID>
    {
      ReqSAPID:this.employeeId
    }
    const httpHeaders = new HttpHeaders({ 
                               });
    return this.http.post<IApproval[]>(this.globalServices.baseUrl + this.getMyRequestUrl, sapId,{headers:httpHeaders})
    .pipe( retry(1), 
      catchError(this.handleError)
      );
  }

  getRoleByAppSliderMyRequest():Observable<IAppByRole[]>{
    this.employeeId=this.global.GetUserLoggedInSAPID();
    const sapId = <SAPID>
    {
      ReqSAPID:this.employeeId
    }
    const httpHeaders = new HttpHeaders({
                                  'Access-Control-Allow-Origin':'Access-Control-Allow-Origin',  //QA
                                 
                                    });
    return this.http.post<IAppByRole[]>(this.globalServices.baseUrl + this.getRoleByAppSliderMyRequestUrl, sapId,{headers:httpHeaders})
    .pipe(tap(data => console.log((data))),retry(1),
    catchError(this.handleError)
    );
  }

  postCancelRequest(employee:IEmployee):Observable<void> {
    this.appInsights.logEvent('Cancel Request',employee);
    const httpHeaders = new HttpHeaders({
                                    'Content-Type': 'application/json'
 
    });
    return this.http.post<void>(this.globalServices.baseUrl+this.postCancelRequestUrl +'CancelDelegationRequest',employee,{headers:httpHeaders})
    .pipe(
      tap(data=> console.log('cancelled Request: '+ JSON.stringify(data))),
      catchError(this.handleError)
    );
  }

  getDocumentByDatails(document:IDocument[]):Observable<any>{

    const httpHeaders = new HttpHeaders({
                          'Content-Type':'application/json'    
                               });
    return this.http.post<any>(this.globalServices.baseUrl+this.getDocuNameUrl,document,{headers:httpHeaders})
    .pipe(
      tap(data=> console.log('documentanmeservice '+ JSON.stringify(data))),
      catchError(this.handleError)
    );
  }

//#endregion

//#region CommonMethodDashBoard

  private handleError(err: HttpErrorResponse){
    let errorMessage='';
    if (err.error instanceof ErrorEvent) 
    {
      errorMessage = `An error occurred : ${err.error.message}`;
    }
    else 
    {
      errorMessage=`Server returned code: ${err.status}, errorMessage is : ${err.message}`;
    }
    //console.error(errorMessage);
    return  throwError(errorMessage);
  }
//#endregion  
}
        
                      

            





